import styles from './InputWithLabel.module.scss'

function ErrorLabel({ errorText }) {
  return (
    <div className={styles.errorContainer}>
      <span>&#9888;</span>
      <span>{errorText}</span>
    </div>
  )
}

export default ErrorLabel
